import { render } from "./PurchaseReturnReport.vue?vue&type=template&id=85a7b5d4"
import script from "./PurchaseReturnReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__